import { Col, GRID } from '../../components/custom';

export default function DEI()
{
    return (
        <Col id='DEI' className='usecase'>
            <Col className='banner'>
                <span className='title'>Use Case: Investigating the Role of Gender, Region, and Tenure in Employee Engagement</span>
            </Col>
            <Col className='section objective'>
                <span className='title'>Objective</span>
                <span className='descsmall'>The aim of this analysis was to examine the impact of <strong>gender, region, and tenure</strong> on employee engagement scores. The results will help the company understand how different factors affect engagement and enable the design of targeted strategies for improving engagement across various employee groups.</span>
            </Col>
            <Col className='section methodology'>
                <span className='title'>Methodology</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Data Collection:</span>
                        <span className='descsmall'>Engagement scores were gathered from employees categorized by <strong>gender, region, and tenure.</strong></span>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Example Data Breakdown:</span>
                        <ul>
                            <li className='descsmall'><strong>Gender:</strong> Male, Female</li>
                            <li className='descsmall'><strong>Region:</strong> US, EU, Asia</li>
                            <li className='descsmall'><strong>Tenure:</strong> 0-2 years, 2-5 years, 5+ years</li>
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Statistical Test:</span>
                        <span className='descsmall'>A <strong>One-Way ANOVA</strong> was performed to test for significant differences in engagement scores based on <strong>gender, region, and tenure.</strong></span>
                    </Col>
                </Col>
            </Col>
            <Col className='section results'>
                <span className='title'>Key Findings</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Gender</span>
                        <span className='descsmall'><strong>p-value:</strong> 0.0135</span>
                        <span className='descsmall'>There is a statistically significant difference in engagement scores between male and female employees.</span>
                        <GRID className='_2x3'>
                            <span className='descsmall bold'>Gender</span>
                            <span className='descsmall bold'>Engagement Score (Mean)</span>
                            <span className='descsmall bold left'>Male</span>
                            <span className='descsmall'>72.57</span>
                            <span className='descsmall bold left'>Female</span>
                            <span className='descsmall'>83.57</span>
                        </GRID>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Region</span>
                        <span className='descsmall'><strong>p-value:</strong> 0.0076</span>
                        <span className='descsmall'>Engagement scores differ significantly across regions (US, EU, and Asia).</span>
                        <GRID className='_2x4'>
                            <span className='descsmall bold'>Region</span>
                            <span className='descsmall bold'>Engagement Score (Mean)</span>
                            <span className='descsmall bold'>US</span>
                            <span className='descsmall'>75.00</span>
                            <span className='descsmall bold'>EU</span>
                            <span className='descsmall'>80.33</span>
                            <span className='descsmall bold'>Asia</span>
                            <span className='descsmall'>78.00</span>
                        </GRID>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Tenure</span>
                        <span className='descsmall'><strong>p-value:</strong> 0.0076</span>
                        <span className='descsmall'>Engagement scores differ based on employee tenure, with employees in the 2-5 years and 5+ years categories showing higher engagement than those in the 0-2 years group.</span>
                        <GRID className='_2x4'>
                            <span className='descsmall bold'>Tenure</span>
                            <span className='descsmall bold'>Engagement Score (Mean)</span>
                            <span className='descsmall bold'>0-2</span>
                            <span className='descsmall'>72.00</span>
                            <span className='descsmall bold'>2-5</span>
                            <span className='descsmall'>78.00</span>
                            <span className='descsmall bold'>5+</span>
                            <span className='descsmall'>80.67</span>
                        </GRID>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Insightful Takeaway:</span>
                        <span className='descsmall'><strong>By Gender:</strong></span>
                        <ul><li className='descsmall'>There is a significant difference in engagement between male and female employees. Female employees have higher engagement scores on average. This insight may suggest the need for tailored engagement strategies for each gender to foster greater participation and satisfaction.</li></ul>
                        <span className='descsmall'><strong>By Region:</strong></span>
                        <ul><li className='descsmall'>Engagement varies significantly across regions. Employees in the EU reported the highest engagement, followed by Asia and the US. Understanding regional differences can help in designing engagement initiatives that cater to specific regional needs.</li></ul>
                        <span className='descsmall'><strong>By Tenure:</strong></span>
                        <ul><li className='descsmall'>Tenure has a clear influence on engagement levels, with employees who have been with the company longer showing higher engagement scores. Companies should focus on strengthening engagement programs for newer employees to increase long-term satisfaction and retention.</li></ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Next Steps:</span>
                        <ul>
                            <li className='descsmall'><strong>Tailored Engagement Strategies:</strong> Develop gender- and region-specific programs to address the needs of different employee groups.</li>
                            <li className='descsmall'><strong>Focus on Tenure-Based Initiatives:</strong> Implement initiatives that increase engagement for new hires, particularly in the 0-2 year tenure group, while maintaining the high engagement levels of long-tenured employees.</li>
                        </ul>
                    </Col>
                </Col>
            </Col>
        </Col>
    )
}